import { gql } from '__generated__';

export default gql(`
  mutation AddCoupon($input: AddCouponInput!) {
    addCoupon(input: $input) {
      id
    }
  }
`);
